export const CLINIC_SETTINGS_TABS = [
  "profile",
  "conversation-appearance",
  "conversation-labels",
  "blocked-answers",
  "team",
  "templates",
  "quick-messages",
  "booking-availability",
  "planned-closures",
];

export function normalizeClinicSettingsTab(tab) {
  return CLINIC_SETTINGS_TABS.includes(tab) ? tab : "profile";
}

export function buildClinicSettingsPath(tab) {
  return `/settings/${normalizeClinicSettingsTab(tab)}`;
}

export function buildClinicSettingsTabKeys({
  permissions,
  enableQuickMessages = false,
}) {
  return CLINIC_SETTINGS_TABS.filter((key) => {
    if (key !== "quick-messages") return true;
    return enableQuickMessages && permissions.has("manage_templates");
  });
}

export function buildClinicNavKeys({
  permissions,
  enableExperienceIntelligence = false,
}) {
  return [
    "conversations",
    ...(permissions.has("manage_reminders") ? ["reminders"] : []),
    ...(permissions.has("view_dashboard") ? ["dashboard"] : []),
    ...(permissions.has("view_dashboard") && enableExperienceIntelligence ? ["clinic-insights"] : []),
    ...(permissions.has("manage_knowledge") ? ["knowledge"] : []),
    ...(permissions.has("view_patients") ? ["patients"] : []),
    ...(permissions.has("manage_billing") ? ["billing"] : []),
    ...(permissions.has("manage_clinic_settings") ? ["settings"] : []),
  ];
}
